/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgBookmarkOutline = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  "aria-hidden": !props['aria-label'],
  focusable: "false",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.5 1L4.00016 0.5L12.0002 0.502519L12.5 1.00252V15.2525L11.6797 15.6364L7.99861 12.5654L4.32045 15.6363L3.5 15.2525V1ZM4.5 1.50016V14.1837L7.67804 11.5303L8.31879 11.5302L11.5 14.1842V1.50236L4.5 1.50016Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.88112 2.71137L7.40403 4.1797H5.86012L5.78665 4.40583L7.03569 5.31331L6.5586 6.78165L6.75096 6.92141L8 6.01392L9.24904 6.92141L9.4414 6.78165L8.96431 5.31331L10.2134 4.40583L10.1399 4.1797H8.59597L8.11888 2.71137H7.88112Z"
}));

export default SvgBookmarkOutline;